import { SimuliveVideoRoomState } from '.';

import { RootState } from '@/store';

const getters = {
  isHlsNetworkLoading(state: SimuliveVideoRoomState, g: any, rootState: RootState, rootGetters: any) {
    const isLoadError = state.isHLSFragLoadError || state.isHLSLevelLoadError || state.isHLSManifestLoadError;

    if (isLoadError && state.hasVideoPlaybackStalled) {
      return true;
    }

    return false;
  },
  shouldUseInhouseSimulive(state: SimuliveVideoRoomState, g: any, rootState: RootState, rootGetters: any) {
    const broadcast = rootGetters['event/currentBroadcast'];
    if (!broadcast?.use_medialive_channel) {
      // No Medialive channel support, so forcing Inhouse Simulive
      return true;
    }
    return !state.forceSwitchToNonInHouseSimulive && rootState.event?.useInHouseSimulive;
  }
};

export default getters;
export type SimuliveVideoRoomGetters = typeof getters;
